export default __webpack_public_path__ + "static/media/ctbc-g.dbc30649.png";